import type { ReactNode } from "react";
import { Heading } from "../atoms/Heading";
import { Text } from "../atoms/Text";
import { cn } from "../lib/cn";
import {
	RespaServiceItem,
	type RespaServiceItemProps,
} from "./RespaServiceItem";

export interface RespaChecklistProps {
	services: RespaServiceItemProps[];
	completedCount: number;
	totalServices: number;
	/**
	 * Platform-internal RESPA threshold flag. Accepted for backward
	 * compatibility but deliberately never surfaced as a pass/fail verdict —
	 * coverage is presented neutrally instead, with no legal-compliance claim.
	 */
	compliant?: boolean;
	className?: string;
}

function RespaChecklist({
	services,
	completedCount,
	totalServices,
	className,
}: RespaChecklistProps): ReactNode {
	return (
		<div
			className={cn("flex flex-col gap-4", className)}
			aria-label="Settlement-service coverage"
		>
			<div className="flex flex-col gap-1">
				<Heading size="md">Settlement-service coverage</Heading>
				<Text size="sm" textColor="mutedForeground">
					{completedCount} of {totalServices} settlement-service categories have
					recorded actions.
				</Text>
			</div>

			<ul className="flex flex-col gap-2" aria-label="Service list">
				{services.map((service) => (
					<li key={service.code}>
						<RespaServiceItem {...service} />
					</li>
				))}
			</ul>
		</div>
	);
}
RespaChecklist.displayName = "RespaChecklist";

export default RespaChecklist;
export { RespaChecklist };
